import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import MilitaryForm from 'common/form/MilitaryForm';
import { BarLoader, Button } from '@unite-us/app-components';
import { Dialog } from '@unite-us/ui';
import EditButton from 'common/display/Profile/components/EditButton';
import { cleanMilitaryFields } from 'src/components/MilitaryInformation/utils';
import {
  useInvalidateQueries,
} from 'src/api/APIHooks';
import MilitaryInformationDisplay from './components/MilitaryInformationDisplay';

const MilitaryInformation = (props) => {
  const invalidateQueries = useInvalidateQueries();
  let editDialog = null;
  const [state, setState] = useState({
    verb: '',
    submitting: false,
  });
  const [formSubmitRef, setFormSubmitRef] = useState(null);

  const onSubmit = useCallback((data) => {
    setState((prev) => ({ ...prev, submitting: true }));
    const cleanedData = cleanMilitaryFields(data);
    props.updateMilitaryInformation(cleanedData);

    setState((prev) => ({ ...prev, submitting: false }));
    invalidateQueries('person');

    if (editDialog) {
      editDialog.closeDialog('saved');
    }
  }, [props.updateMilitaryInformation, invalidateQueries]);

  const edit = (isAdd = false) => {
    setState((prev) => ({
      ...prev,
      verb: isAdd ? 'Add' : 'Edit',
    }));
    if (editDialog) {
      editDialog.openDialog();
    }
  };

  const handleAddMilitaryInfoClick = (e) => {
    e.preventDefault();
    edit(true);
  };

  const submitMilitaryForm = () => {
    if (formSubmitRef) {
      formSubmitRef();
    }
  };

  const {
    contact,
    enums,
    hideHeader,
    submitting,
  } = props;

  const militaryInfo = () => {
    if (!contact.has_military) {
      return (
        <span
          className="military-information-add-info"
          onClick={handleAddMilitaryInfoClick}
          role="button"
          tabIndex={0}
        >
          Add Military Information
        </span>
      );
    }

    return (
      <MilitaryInformationDisplay
        action={state.verb}
        contact={contact}
        edit={edit}
        enums={enums}
        submitting={submitting}
      />
    );
  };

  const editSection = () => (
    <div className="edit-modal">
      {
        contact.has_military &&
        <EditButton edit={edit} id="edit-military-btn" aria-label="edit military information" />
      }
      <Dialog
        modal
        ref={(el) => { editDialog = el; }}
        title={`${state.verb} Military Information`}
        id="military-info-modal"
        actions={[
          <Button
            id="edit-military-cancel-btn"
            label="Cancel"
            disabled={state.submitting}
            onClick={() => editDialog && editDialog.closeDialog()}
          />,
          <Button
            id="edit-military-save-btn"
            label="Save"
            primary
            style={{ marginLeft: '10px' }}
            disabled={state.submitting}
            onClick={submitMilitaryForm}
          />,
        ]}
      >
        <Form
          onSubmit={onSubmit}
          initialValues={contact.military || {}}
          render={({ handleSubmit }) => {
            if (!formSubmitRef) {
              setFormSubmitRef(() => handleSubmit);
            }
            return (
              <form onSubmit={handleSubmit}>
                <MilitaryForm />
              </form>
            );
          }}
        />
      </Dialog>
    </div>
  );

  return (
    <div className="profile-panel military-information editable-panel">
      <div>
        {!hideHeader && <h3>Military Information</h3>}

        <div className="section-body">
          {submitting ? (<BarLoader size="half" tall />) : militaryInfo()}

          {editSection()}
        </div>
      </div>
    </div>
  );
};

MilitaryInformation.propTypes = {
  contact: PropTypes.object.isRequired,
  enums: PropTypes.object.isRequired,
  hideHeader: PropTypes.bool,
  submitting: PropTypes.bool,
  updateMilitaryInformation: PropTypes.func.isRequired,
};

MilitaryInformation.defaultProps = {
  hideHeader: false,
  submitting: false,
};

export default MilitaryInformation;
